import { ETimeUnit } from '@/constants';

import getFromDate from './getFromDate';

/** Возвращает месяц для даты в диапазоне от 0 до 11 (0 - Январь) */
const getMonthsFromDate = getFromDate(ETimeUnit.month);

export default getMonthsFromDate;
